module.exports = __webpack_public_path__ + "static/media/K.394614ad.jpg";